import React from 'react';
import './PlagiarizeLink.scss';

class QuestionItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { current, data } = this.props;
    if (current.docid === data.docid && (prevProps.current.docid !== current.docid)) {
      this.setState({ show: true });
    }
  }

  handlePrevDetailClick = () => {
    const { show } = this.state;
    this.setState({
      show: !show,
    })
  };

  render() {
    const { data } = this.props;
    const { show } = this.state;
    return (
      <div className="question-item">
        <div className="question-item__title" role="none" onClick={this.handlePrevDetailClick}>
          <span className={`${show ? 'active' : ''}`} />
          <div>{data.title}</div>
        </div>
        {show ? (<div className="question-item__body" dangerouslySetInnerHTML={{ __html: data.body }} />) : null}
      </div>
    );
  }
}

export default QuestionItem;
